import { render } from "./Card.vue?vue&type=template&id=52ec12a8"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Goal/Card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52ec12a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52ec12a8', __exports__)) {
    api.reload('52ec12a8', __exports__)
  }
  
  module.hot.accept("./Card.vue?vue&type=template&id=52ec12a8", () => {
    api.rerender('52ec12a8', render)
  })

}


export default __exports__